export default __webpack_public_path__ + "static/media/resume_latest.c5c411d4.pdf";